<template>
  <card style="height: 33%;">
    <div class="device-picker" style="right: auto;left: 20px;top: 12px;">
      性诱诱捕器
    </div>

    <echart
      chartId="trap"
      :options="options"
      :height="height - 52"
      style="margin-top: 52px;"
    ></echart>
  </card>
</template>

<script>
import mixin from '../mixin'
import moment from 'moment'
import Card from '../card'
import Echart from '@/components/Chart'
import { getPreview } from '@/service/trap'

export default {
  mixins: [mixin],
  components: { Echart, Card },
  data() {
    return {
      begin: moment()
        .subtract(7, 'days')
        .format('YYYY-MM-DD'),
      end: moment().format('YYYY-MM-DD'),
      analysis: [],
      summary: []
    }
  },
  computed: {
    xAxis() {
      const { begin, end } = this
      const bm = moment(begin)
      const em = moment(end)
      let xAxis = [bm.format('YYYY-MM-DD')]
      let current = moment(begin)

      while (current.isBefore(em)) {
        current = current.add(1, 'd')
        xAxis.push(current.format('YYYY-MM-DD'))
      }
      return xAxis
    },
    options() {
      let { summary = [], xAxis } = this
      return {
        legend: {
          type: 'scroll',
          left: 20,
          right: 20,
          bottom: 12,
          pageButtonGap: 20,
          textStyle: { color: '#9aa8d4' },
          pageTextStyle: { color: '#dcdfe6', fontSize: 14 }
        },
        xAxis: {
          type: 'category',
          data: this.xAxis
        },
        yAxis: {
          type: 'value',
          splitLine: { show: false }
        },
        grid: {
          top: 10,
          left: 20,
          right: 40,
          bottom: 50
        },
        series: this.traps.map(d => {
          const data = summary.filter(o => o.deviceId === d.id)
          return {
            name: d.name,
            type: 'bar',
            data: xAxis.map(x => {
              const cells = data.filter(l => l.date === x)
              return cells.reduce((total, cur) => (total += cur.count), 0)
            })
          }
        })
      }
    }
  },
  mounted() {
    this.getPreview()
  },
  methods: {
    async getPreview() {
      const { data } = await getPreview({
        companyId: this.companyId,
        begin: this.begin,
        end: this.end
      })
      this.summary = data
    }
  }
}
</script>

<style lang="css" scoped></style>
